import { NewDwellingListingsComponent } from '../new-dwellings-map/new-dwelling-listings/new-dwelling-listings.component';
export const NEW_DWELLINGS_MAP_ROUTES = [
    {
        path: 'market',
        component: NewDwellingListingsComponent,
    },
];
